const MuiDialogActions = {
  styleOverrides: {
    root: {
      padding: '24px',
    },
  },
};

export default MuiDialogActions;
